import React from 'react'

export interface NumberRangeProps {
  min: string
  max: string
  onChange: (next: { min: string; max: string }) => void
  unit?: string
  label: string
  placeholderMin?: string
  placeholderMax?: string
}

/** One bounded/unbounded numeric filter control; empty endpoints remain empty. */
export function NumberRange({
  min,
  max,
  onChange,
  unit,
  label,
  placeholderMin,
  placeholderMax,
}: NumberRangeProps) {
  return (
    <div className="flex h-[var(--ctl-h)] items-center rounded-[var(--radius)] border border-border bg-background px-3 focus-within:border-foreground focus-within:outline-2 focus-within:outline-[var(--fg-soft)]">
      <input
        aria-label={`${label}下限`}
        inputMode="decimal"
        value={min}
        placeholder={placeholderMin}
        className="min-w-0 flex-1 border-0 bg-transparent p-0 text-right font-mono text-base tabular-nums text-foreground outline-none"
        onChange={(event) => onChange({ min: event.target.value, max })}
      />
      <span className="px-2 text-muted" aria-hidden="true">–</span>
      <input
        aria-label={`${label}上限`}
        inputMode="decimal"
        value={max}
        placeholder={placeholderMax}
        className="min-w-0 flex-1 border-0 bg-transparent p-0 text-right font-mono text-base tabular-nums text-foreground outline-none"
        onChange={(event) => onChange({ min, max: event.target.value })}
      />
      {unit ? <span className="pointer-events-none ml-2 select-none text-sm text-muted">{unit}</span> : null}
    </div>
  )
}
